import React from "react";
import styles from "./RunningTightOnBudgetBottomSheet.module.scss";
import Button from "@src/components/UIElements/Button";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { tightOnBudgetBottomSheetCloseAction } from "@src/components/Tabs/Overview/store/actions.js";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { openInstallmentUtil } from "../../../Tabs/Overview/components/OverviewContent/utility";
import { quitWebviewDeeplink } from "@src/utils/goBack";
const RunningTightOnBudgetBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showRunningTightOnBudgetBottomSheet
  );
  const courseDetails = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const data = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.installments
  );
  // console.log(courseDetails, "runn");
  const handleClose = () => {
    dispatch(actionCreator.showRunningTightOnBudgetBottomSheetAction(false));
    dispatch(
      tightOnBudgetBottomSheetCloseAction({
        courseId: courseDetails?.metaData?.id,
        activeInstallmentId:
          courseDetails?.installments?.activeInstallmentId ||
          courseDetails?.installments?.installmentId,
      })
    );
  };
  const selectedState = useSelector(
    (state) => state?.overviewReducer?.stateSelected
  );
  const handleInstallmentCardClick = () => {
    // let newDeeplink = { ...data?.installmentAlert?.button?.deeplink };
    // if (selectedState) {
    //   let newUrl = new URL(newDeeplink.paramOne);
    //   newUrl.searchParams.append("state", `${selectedState}`);
    //   newDeeplink.paramOne = newUrl.toString();
    // }
    // console.log(newDeeplink, "newDeeplink");
    // directDeepLink({}, "UTIL_WEBVIEW", false)(newDeeplink);
    openInstallmentUtil(selectedState);
  };
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        handleClose();
      }}
    >
      <div className={styles.PaymentInstallment}>
        <div className={styles.PaymentInstallment__image}>
          <Image
            src={getAwsAssets("rupeeIcon.svg", "bottomSheets")}
            width="74px"
            height="74px"
            alt={t(
              "components.bottomSheets.components.runningTightOnBudgetBottomSheet.rupeeIcon",
              "rupeeIcon"
            )}
          />
        </div>
        <h1 className={styles.PaymentInstallment__heading}>
          {data?.installmentAlert?.heading}
        </h1>
        <p className={styles.PaymentInstallment__subtext}>
          {data?.installmentAlert?.text}
        </p>
        <Button onClick={() => handleInstallmentCardClick()}>
          {t(
            "components.bottomSheets.components.runningTightOnBudgetBottomSheet.payInInstalments",
            "Pay in Installments"
          )}
        </Button>

        <p
          className={styles.PaymentInstallment__goback}
          onClick={() => quitWebviewDeeplink()}
        >
          {t(
            "components.bottomSheets.components.dueDatePaymentBottomSheet.goBackInstead",
            "Go back instead"
          )}
        </p>
      </div>
    </Modal>
  );
};

export default RunningTightOnBudgetBottomSheet;
